export default "__VITE_ASSET__iuQK9LO6__"